(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multicolumn"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('multicolumn-auto-scroll')) {
    customElements.define('multicolumn-auto-scroll', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.start());
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.events?.abort();
        this.clones?.forEach((clone) => clone.remove());
      }

      start() {
        const slider = this.querySelector('.slider');
        if (!slider) return;
        this.events = new AbortController();
        this.clones = [];
        const options = { signal: this.events.signal };
        const mobile = matchMedia('(max-width: 749px)');
        const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
        const originals = Array.from(slider.children);
        const rtl = getComputedStyle(slider).direction === 'rtl';
        let touching = false;
        let hovering = false;
        let resumeAt = performance.now() + 1500;
        let previous = performance.now();
        let position = Math.abs(slider.scrollLeft);

        const updateClones = () => {
          this.clones.forEach((clone) => clone.remove());
          this.clones = [];
          if (mobile.matches && !reducedMotion.matches && originals.length > 1) {
            this.clones = originals.map((original) => {
              const clone = original.cloneNode(true);
              clone.setAttribute('aria-hidden', 'true');
              for (const element of [clone, ...clone.querySelectorAll('*')]) {
                element.removeAttribute('id');
                element.removeAttribute('data-shopify-editor-block');
                element.removeAttribute('data-cascade');
                element.classList.remove('scroll-trigger', 'animate--slide-in', 'scroll-trigger--offscreen');
              }
              clone.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach((element) => {
                element.setAttribute('tabindex', '-1');
              });
              slider.appendChild(clone);
              return clone;
            });
          }
          position = Math.abs(slider.scrollLeft);
        };
        updateClones();
        mobile.addEventListener('change', updateClones, options);
        reducedMotion.addEventListener('change', updateClones, options);
        slider.addEventListener('pointerdown', () => { touching = true; }, options);
        const release = () => {
          if (touching) resumeAt = performance.now() + 2500;
          touching = false;
        };
        window.addEventListener('pointerup', release, options);
        window.addEventListener('pointercancel', release, options);
        slider.addEventListener('pointerenter', (event) => {
          if (event.pointerType === 'mouse') hovering = true;
        }, options);
        slider.addEventListener('pointerleave', () => { hovering = false; }, options);
        slider.addEventListener('wheel', () => {
          resumeAt = performance.now() + 2500;
        }, { ...options, passive: true });

        const tick = (now) => {
          if (!this.isConnected) return;
          const elapsed = Math.min(now - previous, 50);
          previous = now;
          const bounds = slider.getBoundingClientRect();
          const visible = bounds.bottom > 0 && bounds.top < innerHeight;
          const focused = slider.contains(document.activeElement);
          const cycle = this.clones.length ? Math.abs(
            this.clones[0].getBoundingClientRect().left - originals[0].getBoundingClientRect().left
          ) : 0;
          if (mobile.matches && !reducedMotion.matches && !document.hidden && visible &&
              !touching && !hovering && !focused && now >= resumeAt && cycle > 0) {
            position = (position + 30 * elapsed / 1000) % cycle;
            slider.scrollLeft = rtl ? -position : position;
          } else {
            position = Math.abs(slider.scrollLeft);
          }
          this.frame = requestAnimationFrame(tick);
        };
        this.frame = requestAnimationFrame(tick);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
